var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("../../assets/images/back.png")},on:{"click":_vm.back}}),_vm._v("提交成功 ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"succ"},[_c('img',{attrs:{"src":require("../../assets/images/tijiao.png")}}),_c('div',[_vm._v("提交成功，感谢您的反馈")])])
}]

export { render, staticRenderFns }